<ng-container>

	<mat-card (cdkDragEnded)="_dragEnd($event);" (mousedown)="_mouseDown($event);" [cdkDragFreeDragPosition]="position" [ngStyle]="_visible()" cdkDrag cdkDragBoundary=".desktop" class="drag-box patter-table panel">
		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" class="close-button" color="primary" mat-icon-button id="mat-change-button">
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{title}}</div>
		</div>
		<mat-card-content class="panel-content" fxLayout="row">
			<div *ngIf="locked" cdkDragHandle></div>

			<div fxLayout="column">
				<div>{{name}}</div>
				<ngx-charts-line-chart
					[results]="dataSource"
					[scheme]="colorScheme"
					[view]="size"
					[xAxisLabel]="xAxisLabel"
					[xAxisTickFormatting]="xAxisFormat"
					[yAxisLabel]="yAxisLabel"
					[yScaleMax]="100"
					[yScaleMin]="1"
					autoScale="true"
					class="dark"
					roundDomains="true"
					showXAxisLabel="false"
					showYAxisLabel="true"
					style="fill: #ffffff;"
					tooltipDisabled="true"
					xAxis="true"
					yAxis="true">
				</ngx-charts-line-chart>
			</div>

			<ng-template #noData>
				<mat-card style="background-color:#cdcdcd;">
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>

</ng-container>


